export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).replace(',', '');
  };

  export const formatToGbIsoDateTime = (dateString) => {
    const parsedDate = new Date(dateString)
    const [day, month, year] = parsedDate.toLocaleDateString('en-GB').split('/');
    const hours = parsedDate.getHours().toString().padStart(2, '0');
    const minutes = parsedDate.getMinutes().toString().padStart(2, '0');
    const seconds = parsedDate.getSeconds().toString().padStart(2, '0');
    
    // Build ISO 8601 string with local time
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hours}:${minutes}:${seconds}`;
  };

  export const formatGBDatestringToGBIsoDateTime = (dateString) => {
    const [day, month, yearTime] = dateString.split('/');
      const [year, time] = yearTime.split(' ');
    return new Date(`${year}-${month}-${day}T${time}`);
  }